import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SignUpService from '@/features/Auth/services/SignUpService';
import type { OnboardingStep } from '../types/onboarding-types';
import type { OnboardingStatus } from '@/features/Auth/types/onboarding-types';

export const useOnboardingFlow = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState<OnboardingStep>('profile');
  const [canSkipProfileStep, setCanSkipProfileStep] = useState(false);
  const [onboardingData, setOnboardingData] = useState<OnboardingStatus | null>(null);

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      try {
        const response = await SignUpService.checkOnboardingStatus();
        
        if (response.success && response.data) {
          if (!response.data.onboarding_required) {
            navigate('/');
            return;
          }

          // Armazenar dados do onboarding
          setOnboardingData(response.data);

          // Verificar se pode pular a primeira fase (profile step)
          // Isso acontece quando o usuário já tem nome E avatar do OAuth (Google ou Microsoft)
          if (response.data.can_skip_profile_step) {
            setCanSkipProfileStep(true);
            // Definir o step inicial baseado na resposta do backend
            // O backend retorna 'survey' como initial_step quando pode pular profile
            // O frontend decidirá se vai para survey ou organization baseado na config de survey
            setCurrentStep(response.data.initial_step || 'survey');
          }
        }
      } catch (err) {
        // Erro silencioso - fallback para fluxo normal de onboarding
      } finally {
        setIsLoading(false);
      }
    };

    checkOnboardingStatus();
  }, [navigate]);

  return {
    isLoading,
    currentStep,
    setCurrentStep,
    canSkipProfileStep,
    onboardingData,
  };
};
